import { render, staticRenderFns } from "./FixedToolbar.vue?vue&type=template&id=bf2c6710&scoped=true&"
import script from "./FixedToolbar.vue?vue&type=script&lang=js&"
export * from "./FixedToolbar.vue?vue&type=script&lang=js&"
import style0 from "./FixedToolbar.vue?vue&type=style&index=0&id=bf2c6710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2c6710",
  null
  
)

export default component.exports